function init() {
    const disclaimerLinks = document.querySelectorAll('a[data-opens-disclaimer="true"]');

    if (disclaimerLinks.length > 0) {
        // Get modal elements - now looking for them anywhere in the document
        const modalOverlay = document.querySelector('.disclaimer-modal-overlay');
        const globalModal = document.querySelector('#global-disclaimer-modal');
        
        if (!globalModal || !modalOverlay) {
            return;
        }
        
        const modalContent = globalModal.querySelector('.disclaimer-text');
        const proceedButton = globalModal.querySelector('.disclaimer-proceed-btn');
        const body = document.body;
        
        if (!modalContent || !proceedButton) {
            console.error('Modal components not found:', {
                modalContent: modalContent ? 'Found' : 'Not found',
                proceedButton: proceedButton ? 'Found' : 'Not found'
            });
            return;
        }
        
        // Current active link being processed
        let currentLink = null;
        
        // Function to open the modal with dynamic content
        function openModal(link) {            
            
            // Store current link for later use
            currentLink = link;
            
            // Get the necessary data from the link
            const disclaimerText = link.getAttribute('data-disclaimer-text');
            const buttonText = link.getAttribute('data-disclaimer-button-text') || 'Proceed';
            const targetUrl = link.getAttribute('data-original-url');
            const targetAttr = link.getAttribute('data-target');
            
            // Set the content of the modal
            modalContent.innerHTML = disclaimerText;
            proceedButton.textContent = buttonText;
            proceedButton.href = targetUrl;
            
            if (targetAttr) {
                proceedButton.setAttribute('target', targetAttr);
            } else {
                proceedButton.removeAttribute('target');
            }
            
            // Show the modal and overlay
            globalModal.style.display = 'block';
            modalOverlay.style.display = 'block';
            
            // Ensure the overlay is visible with jQuery if available
            if (typeof jQuery !== 'undefined') {
                jQuery('.disclaimer-modal-overlay').show();
            }
            
            // Prevent body scrolling
            body.classList.add('modal-open');
        }
        
        // Function to close the modal
        function closeModal() {
            // Hide the modal
            globalModal.style.display = 'none';
            
            // Hide the overlay
            modalOverlay.style.display = 'none';
            if (typeof jQuery !== 'undefined') {
                jQuery('.disclaimer-modal-overlay').hide();
            }
            
            // Re-enable body scrolling
            body.classList.remove('modal-open');
            
            // Reset the current link
            currentLink = null;
        }
        
        // Set up click handlers for all disclaimer links
        disclaimerLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                console.log('Disclaimer link clicked:', this, 'Data:', {
                    text: this.getAttribute('data-disclaimer-text'),
                    buttonText: this.getAttribute('data-disclaimer-button-text'),
                    url: this.getAttribute('data-original-url')
                });
                openModal(this);
            });
        });
        
        // Set up click handlers for close buttons
        const closeButtons = globalModal.querySelectorAll('.disclaimer-close, .disclaimer-cancel-btn');
        closeButtons.forEach(button => {
            button.addEventListener('click', function() {
                console.log('Close button clicked');
                closeModal();
            });
        });
        
        // Close modal when clicking on the overlay
        modalOverlay.addEventListener('click', function() {
            closeModal();
        });
        
        // Prevent closing when clicking inside the modal content
        const modalContentContainer = globalModal.querySelector('.disclaimer-modal-content');
        if (modalContentContainer) {
            modalContentContainer.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
        
        // Close modal with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeModal();
            }
        });
    }
}

export { init as default }